var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevronRightRound(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi_2767192",
    clipPath: "url(#clip0_268_221308)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Right",
    d: "M14 0C6.28053 0 0 6.28053 0 14C0 21.7195 6.28053 28 14 28C21.7195 28 28 21.7195 28 14C28 6.28053 21.7195 0 14 0ZM14 26.25C7.24522 26.25 1.75 20.7548 1.75 14C1.75 7.24522 7.24522 1.75 14 1.75C20.7548 1.75 26.25 7.24522 26.25 14C26.25 20.7548 20.7548 26.25 14 26.25ZM19.8686 13.3814C20.2105 13.7233 20.2105 14.2769 19.8686 14.6186L15.4936 18.9936C15.3228 19.1645 15.0988 19.25 14.875 19.25C14.6512 19.25 14.4272 19.1645 14.2564 18.9936C13.9145 18.6517 13.9145 18.0981 14.2564 17.7564L17.1378 14.875H8.75C8.26678 14.875 7.875 14.4837 7.875 14C7.875 13.5163 8.26678 13.125 8.75 13.125H17.1378L14.2564 10.2436C13.9145 9.90172 13.9145 9.34806 14.2564 9.00638C14.5983 8.66469 15.1519 8.66447 15.4936 9.00638L19.8686 13.3814Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_268_221308"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRightRound);
export default __webpack_public_path__ + "static/media/chevronRightRound.b5a79998c5ef041f088dc7a5e1725ed5.svg";
export { ForwardRef as ReactComponent };